module.exports = __webpack_public_path__ + "static/media/md-cloud-download.47419780.svg";